var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"df119438cdaae0d92f31f30b895b1a8cb94c3f66"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["availroom-os@availroom"]={id:"df119438cdaae0d92f31f30b895b1a8cb94c3f66"};
      